// extracted by mini-css-extract-plugin
export default {"thunderImg":"Thunder_thunderImg__a-fvF","thunderFade":"Thunder_thunderFade__xoFoh"};